import { createAppSlice } from 'creators';
import { AxiosResponse } from 'axios';

import { get, post } from 'api/requests';

import { IPhoto as IMedia } from 'pages/ApartmentStatus/types';

import { IMAGE, Statuses } from 'consts';

interface MediaState {
  loading: boolean;
  saveLoading: boolean;
  data: IMedia[];
  requestId: string | null;
}

const initialState: MediaState = {
  loading: false,
  saveLoading: false,
  requestId: null,
  data: [],
};

export const mediaSlice = createAppSlice({
  name: 'apartmentStatusMediaSlice',
  initialState,
  reducers: create => ({
    //
    // reset
    //
    reset: create.reducer(() => initialState),
    //
    // getMedia
    //
    getMedia: create.asyncThunk(
      async (
        { placementId, mediaStatus }: { placementId: number; mediaStatus: Statuses },
        { rejectWithValue },
      ) => {
        try {
          const { data } = await get<IMedia[]>(
            `/api/standards/placements/${placementId}/media/?status=${mediaStatus}`,
          );
          return data;
        } catch (error) {
          return rejectWithValue(error);
        }
      },
      // Обработка состояний запроса getMedia
      {
        pending: (state, { meta }) => {
          state.loading = true;
          state.requestId = meta.requestId;
        },
        rejected: (state, { meta }) => {
          if (state.requestId === meta.requestId) {
            state.loading = false;
          }
        },
        fulfilled: (state, { payload }) => {
          state.loading = false;
          state.requestId = null;

          if (payload) {
            state.data = payload;
          }
        },
      },
    ),
    //
    // saveMedia
    //
    saveMedia: create.asyncThunk(
      async (respData: RespData, thinkApi) => {
        const { placementId, media } = respData;
        try {
          const { data } = await post<RespParams, AxiosResponse<IMedia[]>>(
            '/api/standards/placements/media/add/',
            {
              placement_id: placementId,
              media: media,
            },
          );
          return data;
        } catch (error) {
          return thinkApi.rejectWithValue(error);
        }
      },
      // Обработка состояний запроса saveMedia
      {
        pending: (state, { meta }) => {
          state.saveLoading = true;
          state.requestId = meta.requestId;
        },
        rejected: (state, { meta }) => {
          if (state.requestId === meta.requestId) {
            state.saveLoading = false;
          }
        },
        fulfilled: (state, { payload }) => {
          state.saveLoading = false;
          state.requestId = null;

          if (payload) {
            state.data = payload;
          }
        },
      },
    ),
  }),
});

export const { reset: setReset, getMedia, saveMedia } = mediaSlice.actions;

interface Media {
  link: string;
  kind: typeof IMAGE;
}

interface RespData {
  placementId: number;
  media: Media[];
}

interface RespParams {
  placement_id: number;
  media: Media[];
}
